module.exports = "<div class=\"c-box-el\" :class=\"{ 'c-box-el--less-margin-bottom': isSelected }\" @keyup.enter=\"isSelected = !isSelected\" @keyup.esc=\"isSelected = false\" tabindex=\"0\" aria-live=\"polite\">\n    <div class=\"c-box-el__header\" v-if=\"!noHeader\" @click=\"selectEl(this)\">\n        <slot name=\"title\"></slot>\n        <div class=\"o-btn__open\" :class=\"{ 'o-btn__open--close': isSelected }\"></div>\n    </div>\n    <div class=\"c-box-el__body js-slide-down-up\" v-show=\"noHeader\">\n        <slot name=\"content\"></slot>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./assets/_js/components/box-el/box-el.vhtml
// module id = 293
// module chunks = 0